import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateLanguageService } from '../../services/translate-language.service';

@Component({
  selector: 'app-unsupported-device',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './unsupported-device.component.html',
  styleUrl: './unsupported-device.component.scss'
})
export class UnsupportedDeviceComponent {
  public readonly translate = inject(TranslateService);
  public readonly languageService = inject(TranslateLanguageService);
}
